import { createSlice } from '@reduxjs/toolkit';

const playerSlice = createSlice({
  name: 'player',
  initialState: { mixtape: null, isPlaying: false, loadId: 0, crossfade: false },
  reducers: {
    loadMixtape: (state, action) => {
      const { crossfade = false, ...mixtape } = action.payload;
      state.mixtape = mixtape;
      state.isPlaying = true;
      state.crossfade = crossfade;
      state.loadId += 1;
    },
    setPlaying: (state, action) => {
      state.isPlaying = action.payload;
    },
    togglePlaying: (state) => {
      state.isPlaying = !state.isPlaying;
    },
    stopMixtape: (state) => {
      state.mixtape = null;
      state.isPlaying = false;
    }
  }
});

export const { loadMixtape, setPlaying, togglePlaying, stopMixtape } =
  playerSlice.actions;
export default playerSlice.reducer;
